var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletloader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4889 29.5536C31.2195 31.4974 31.7352 34.0759 33.679 35.385C35.6228 36.6544 38.2013 36.1387 39.5104 34.1949C40.7798 32.2511 40.2641 29.6726 38.3203 28.3635C36.3369 27.0941 33.7583 27.6495 32.4889 29.5536Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48892 13.8051C7.2195 15.7489 7.7352 18.3274 9.679 19.6365C11.6228 20.9059 14.2013 20.3902 15.5104 18.4464C16.8195 16.5026 16.2641 13.9241 14.3203 12.615C12.3765 11.3456 9.79801 11.9009 8.48892 13.8051Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4973 12.6149C37.8047 16.7405 39.5502 25.2297 35.4246 31.4975C34.6708 32.6479 33.7584 33.6793 32.727 34.5124C33.0047 34.8297 33.3221 35.1471 33.6791 35.3851C33.7188 35.3851 33.7584 35.4248 33.7584 35.4248C34.8295 34.5124 35.7419 33.4413 36.575 32.2512C41.1369 25.3091 39.1931 15.9868 32.251 11.4248C27.6097 8.37024 21.9369 8.21156 17.2956 10.5124C17.6527 10.8297 17.97 11.2264 18.2477 11.6231C22.413 9.719 27.4113 9.91735 31.4973 12.6149ZM30.7039 37.4876C26.0626 39.7884 20.3898 39.6297 15.7485 36.5752C8.80637 32.0132 6.86257 22.6909 11.4246 15.7488C12.2179 14.519 13.17 13.4876 14.2411 12.5752C14.2808 12.5752 14.3204 12.6149 14.3204 12.6149C14.7171 12.8529 15.0345 13.1702 15.2725 13.4876C14.2411 14.3207 13.3287 15.3521 12.575 16.5025C8.44935 22.8099 10.1948 31.2595 16.5022 35.3851C20.5882 38.0826 25.5865 38.281 29.7518 36.3769C30.0295 36.7735 30.3469 37.1306 30.7039 37.4876Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletloader);
export default __webpack_public_path__ + "static/media/walletloader.502b79d3290d3d9a7939a825039a40af.svg";
export { ForwardRef as ReactComponent };